var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3867 7.01128H15.7617V3.63628",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3752 13.3752C12.5099 14.2406 11.4074 14.8299 10.2071 15.0686C9.00686 15.3074 7.76276 15.1848 6.63215 14.7165C5.50153 14.2482 4.53517 13.4551 3.85528 12.4376C3.17539 11.4201 2.8125 10.2238 2.8125 9C2.8125 7.77623 3.17539 6.57994 3.85528 5.56241C4.53517 4.54488 5.50153 3.75181 6.63215 3.28349C7.76276 2.81518 9.00686 2.69264 10.2071 2.93139C11.4074 3.17014 12.5099 3.75944 13.3752 4.62478L15.7617 7.01126",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestart);
export default __webpack_public_path__ + "static/media/Restart.fbaebe8fa796566a35658e6dbb39f8dc.svg";
export { ForwardRef as ReactComponent };